import { render, staticRenderFns } from "./activity-detail.vue?vue&type=template&id=6b4ff912&scoped=true&"
import script from "./activity-detail.vue?vue&type=script&lang=js&"
export * from "./activity-detail.vue?vue&type=script&lang=js&"
import style0 from "./activity-detail.vue?vue&type=style&index=0&id=6b4ff912&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ff912",
  null
  
)

export default component.exports